var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex"},[(_vm.currentField.isType == 'BOX')?_c('button',_vm._b({},'button',_vm.attributesBinding,false)):_c('h4',_vm._b({staticClass:"text-center px-2",class:{
      'rounded-circle': _vm.currentField.isType == 'CIRCLE',
      underline: _vm.currentField.isType == 'UNDERLINE',
    }},'h4',_vm.attributesBinding,false),[_vm._v(" "+_vm._s(_vm.valueText)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }